import React from 'react';
import { MarkupElement, Attachments, formatElementFromHtmlAst, Template } from 'src/functions/formatElement.htmlAst';
import { DefaultTemplateContent } from './ArticleBody.styles';
import { StyledComponent } from 'styled-components';

interface ArticleBodyProps {
  contentHtmlAst?: MarkupElement[];
  articleData?: {
    attachments?: Attachments;
  };
  contentId?: string;
  contentDataSectionName?: string;
  contentTemplateContainer?: StyledComponent<'div', any, Record<string, unknown>, never>;
  children?: React.ReactNode;
  template?: Template;
}

const ArticleBody = ({
  contentHtmlAst,
  articleData,
  contentId,
  contentDataSectionName,
  contentTemplateContainer,
  children,
  template = null,
}: ArticleBodyProps): JSX.Element => {
  const TemplateContent = contentTemplateContainer || DefaultTemplateContent;

  return (
    <TemplateContent
      id={contentId}
      data-section-name={contentDataSectionName}
    >
      {children
        ? children
        : contentHtmlAst.map((child, index) =>
            formatElementFromHtmlAst({
              element: child,
              key: `${index}`,
              attachmentList: articleData?.attachments,
              template,
            })
          )}
    </TemplateContent>
  );
};

export default ArticleBody;
